<template>
  <div>
    <ItemSearchList
      @init="handleItem_init"
      @submit="handleItem_submit"
    />

    <div class="columns my-0 is-multiline">
      <div class="column is-narrow">
        <kst-input floating-label load-on-focus
          field="Search" :data="searchData" :catalog="SearchCatalog"
          @input="handleInput"
        />
      </div>
      <div class="column is-narrow">
        <kst-input floating-label
          field="WarehouseID" :data="searchData" :catalog="SearchCatalog"
          :options="warehouseOptions" @input="handleInput"
        />
      </div>
      <div class="column is-narrow">
        <kst-output addons control-off floating-label status-off
          field="ItemID"
          :data="searchData"
          :catalog="SearchCatalog"
        >
          <template #right>
            <div class="control">
              <template v-if="searchData.ItemID === null">
                <kst-tooltip search-mode hover-only :content="SearchCatalog.ItemID.Label">
                  <kst-button search-mode @click="handleSearch_item"/>
                </kst-tooltip>
              </template>
              <template v-else>
                <kst-tooltip clear-mode hover-only :content="SearchCatalog.ItemID.Label">
                  <kst-button clear-mode @click="handleClear_item"/>
                </kst-tooltip>
              </template>
            </div>
          </template>
        </kst-output>
      </div>
      <div class="column is-narrow">
        <kst-input floating-label
          field="Date" :data="searchData" :catalog="SearchCatalog"
          @input="handleInput"
        />
      </div>
    </div>
  </div>
</template>

<script>
import SearchCatalog from "./SearchCatalog.js";
import Services from "../../../services/Api/StockAvailabilityServices.js";

import ItemSearchList from "../../Item/SearchList/ItemScL.vue";

export default {
  components: {
    ItemSearchList
  },
  props: {
    searchData: Object,
    warehouseOptions: Object
  },
  data: () => ({
    SearchCatalog: SearchCatalog,
    // func
    showItemFunc: null
  }),
  methods: {
    /*** by item modal ***/

    handleItem_init(show) {
      this.showItemFunc = show;
    },
    handleItem_submit(itemData) {
      this.searchData.ItemID = itemData.ID;
      this.searchData.ItemName = itemData.Name;

      this.handleInput();
    },

    /*** custom ***/

    handleInput() {
      this.$emit(this.$kst.Enum.Event.Input);
    },

    handleSearch_item() {
      this.showItemFunc(
        Services.getRelatedItemList
      );
    },

    handleClear_item() {
      this.searchData.ItemID = null;
      this.searchData.ItemName = null;

      this.handleInput();
    }
  }
}
</script>